module.exports = __webpack_public_path__ + "static/media/rencap-SVG-sprite.65899222.svg";